/**
 * Loads a script by dynamically creating a <script> element and appending it to the <head> of the document.
 * @param url - The URL of the script to be loaded.
 */
export function loadScript(url: string) {
    const node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
}